import { Reveal } from "./Reveal";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../ui/accordion";
import { SUBURBS, FAQS } from "../../data/site";

export const LocalAreas = () => (
  <section id="areas" data-testid="areas-section" className="py-28 md:py-36 bg-[#EAE6DF]">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid md:grid-cols-12 gap-14">
        {/* Local SEO editorial content */}
        <div className="md:col-span-7">
          <Reveal>
            <p className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#C26D5C] mb-6">Brisbane & Gold Coast</p>
            <h2 className="font-serif font-light text-5xl md:text-6xl text-[#1A362D] tracking-tight leading-[1.05]">
              Home cleaning & home assistance, close to home.
            </h2>
          </Reveal>
          <Reveal delay={0.05}>
            <div className="mt-6 space-y-4 text-lg text-[#4A5A53] leading-relaxed max-w-xl">
              <p>
                Luxe Home Cleaning & Assistance provides trusted residential cleaning and everyday home
                assistance for busy individuals and families across <strong className="text-[#1A362D]">Brisbane</strong> and
                the <strong className="text-[#1A362D]">Gold Coast</strong>. From a sparkling general or deep clean
                to meal prep, laundry, organisation, dog walking, babysitting and errands, our
                local home assistants help keep your household running smoothly.
              </p>
              <p>
                Moving out? Our bond and exit cleaning is completed to inspection standard. With a
                simple hourly rate, a two-hour minimum and personalised support, dependable help is
                only a quick quote away.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-8">
              <p className="text-sm font-medium text-[#7B8A83] mb-3">Suburbs we service include</p>
              <div className="flex flex-wrap gap-2">
                {SUBURBS.map((s) => (
                  <span key={s} className="text-sm px-3 py-1.5 rounded-full bg-[#F9F8F6] border border-[#D5D1C8] text-[#1A362D]">
                    {s}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        </div>

        {/* FAQ */}
        <div className="md:col-span-5">
          <Reveal delay={0.05}>
            <p className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#C26D5C] mb-6">Good to know</p>
            <h3 className="font-serif text-3xl text-[#1A362D] mb-4">Frequently asked</h3>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border-[#D5D1C8]">
                  <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-serif text-lg text-[#1A362D] hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#4A5A53] text-base leading-relaxed">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
